import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "dayjs/locale/zh-cn";
import locale from "element-plus/lib/locale/lang/zh-cn";
import Cookies from "js-cookie";
import directive from "./directive";
import TRTC from "trtc-js-sdk";

TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.DEBUG);
createApp(App)
  .use(directive)
  .use(store)
  .use(Cookies)
  .use(ElementPlus, { locale })
  .use(router)
  .mount("#app");
